// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"5d5bc990","843":"ae41906c"}[chunkId] + ".chunk.css";
};